import { useEffect, useState } from 'react'

export const IOS_DEVICES_PATTERN = /(Mac|iPhone|iPod|iPad)/i

const MAX_TABLET_SCREEN_WIDTH = 700
const MAX_MOBILE_SCREEN_WIDTH = 480

enum ScreenOrientations {
  Landscape = 'landscape',
  Portrait = 'portrait',
}

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: Math.min(window.innerWidth, window.screen.width),
    height: Math.min(window.innerHeight, window.screen.height),
  })

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: Math.min(window.innerWidth, window.screen.width),
        height: Math.min(window.innerHeight, window.screen.height),
      })
    }

    window.addEventListener('resize', handleResize)

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [setScreenSize])

  return screenSize
}

export const useDeviceView = () => {
  const { width, height } = useScreenSize()
  const [isPortraitOrientation, setIsPortraitOrientation] = useState(
    window.screen.orientation?.type.includes(ScreenOrientations.Portrait),
  )

  useEffect(() => {
    const handleResize = () => {
      setIsPortraitOrientation(window.screen.orientation?.type.includes(ScreenOrientations.Portrait))
    }

    window.screen.orientation?.addEventListener('change', handleResize)

    // Clean up the event listener when the component unmounts
    return () => {
      window.screen.orientation?.addEventListener('change', handleResize)
    }
  }, [setIsPortraitOrientation])

  const isMobileView =
    (!isPortraitOrientation && height < MAX_MOBILE_SCREEN_WIDTH) ||
    (isPortraitOrientation && width < MAX_MOBILE_SCREEN_WIDTH)
  const isTabletView =
    !isMobileView &&
    ((!isPortraitOrientation && height < MAX_TABLET_SCREEN_WIDTH) ||
      (isPortraitOrientation && width < MAX_TABLET_SCREEN_WIDTH))
  const isDesktopView = !isMobileView && !isTabletView

  return { isMobileView, isDesktopView }
}
